import { render, staticRenderFns } from "./WorkflowTab.vue?vue&type=template&id=45538432"
import script from "./WorkflowTab.vue?vue&type=script&lang=js"
export * from "./WorkflowTab.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports